import { useTracking } from '@vp/react-tracking';
import { useEffect, useRef } from 'react';
import { BriefQuery, usePreferredDesignerCount } from '@99designs/feature-design-services-brief';
import { usePage } from '@99designs/tracking';

// Fires once per mount when a preferred-designer brief is viewed, with the number of preferred designers.
export function useTrackPreferredDesignersBriefViewed(
    brief: BriefQuery['brief'] | undefined,
    briefLoading: boolean
) {
    const isPreferredDesignerBrief = Boolean(brief?.request?.invitedDesigners?.[0]);
    const { count, loading: preferredDesignersLoading } =
        usePreferredDesignerCount(isPreferredDesignerBrief);
    const { pageData } = usePage();
    const { tracking } = useTracking();
    const tracked = useRef(false);

    useEffect(() => {
        if (
            tracked.current ||
            briefLoading ||
            !isPreferredDesignerBrief ||
            preferredDesignersLoading
        ) {
            return;
        }

        tracking.track('Preferred Designers Brief Viewed', {
            designerCount: count,
            pageName: pageData.pageName,
            pageSection: pageData.pageSection,
            pageStage: pageData.pageStage,
        });
        tracked.current = true;
    }, [
        briefLoading,
        isPreferredDesignerBrief,
        preferredDesignersLoading,
        count,
        pageData,
        tracking,
    ]);
}
